<template>
  <v-card>
    <v-card-text>
      <h1>Unauthorised</h1>
      <v-btn flat @click="logout">
        <span class="mr-2">sign out</span>
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Unauthorised",
  methods: {
    logout() {
      this.$keycloak.logout({ redirectUri: process.env.VUE_APP_MY_URL });
    },
  },
};
</script>